import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="shell-dark mt-24" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div className="col-span-2">
          <div className="flex items-center">
            <span
              className="font-display font-black text-3xl tracking-tighter bg-clip-text text-transparent"
              style={{ backgroundImage: "linear-gradient(90deg, #ec4cb8 0%, #c026d3 35%, #a855f7 70%, #7c3aed 100%)" }}
            >
              EarnMate
            </span>
          </div>
          <p className="mt-3 text-slate-400 max-w-sm">The mobile-first marketplace for event staffing and skilled freelancers. Hire instantly. Earn instantly.</p>
        </div>
        <div>
          <h4 className="label-eyebrow text-slate-500 mb-3">Discover</h4>
          <ul className="space-y-2">
            <li><Link to="/jobs?type=event_staffing" className="text-slate-300 hover:text-white">Event Staffing</Link></li>
            <li><Link to="/jobs?type=freelance" className="text-slate-300 hover:text-white">Freelance Services</Link></li>
            <li><Link to="/freelancers" className="text-slate-300 hover:text-white">Find Freelancers</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="label-eyebrow text-slate-500 mb-3">Company</h4>
          <ul className="space-y-2">
            <li><Link to="/about" className="text-slate-300 hover:text-white">About</Link></li>
            <li><Link to="/faq" className="text-slate-300 hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="text-slate-300 hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="label-eyebrow text-slate-500 mb-3">Legal</h4>
          <ul className="space-y-2">
            <li><Link to="/privacy-policy" className="text-slate-300 hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-slate-300 hover:text-white">Terms of Service</Link></li>
            <li><Link to="/cookies" className="text-slate-300 hover:text-white">Cookie Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-shell-border px-6 py-4 text-xs text-slate-500 text-center flex flex-wrap justify-center gap-3">
        <span>© {new Date().getFullYear()} EarnMate. Built mobile-first.</span>
        <Link to="/privacy-policy" className="hover:text-slate-300">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-slate-300">Terms of Service</Link>
        <Link to="/cookies" className="hover:text-slate-300">Cookie Policy</Link>
      </div>
    </footer>
  );
}
